import {
	FORMULA_OPERATIONS as FP,
	GeometryTypes,
	PathOperationTypes,
	ShapeType,
} from "../widgets/interfaces/model/enumerations/index";
import { IPresetGeometry } from "../widgets/interfaces/model/geometry/PresetGeometry";

/**
 * Rect preset definition
 * ECMA-376, Third Edition, Part 1 - Fundamentals And Markup Language Reference
 * /OfficeOpenXML-DrawingMLGeometries/presetShapeDefinitions.xml
 */
export const rect: IPresetGeometry = {
	// ahLst: [],
	// avList: [],
	gdLst: [
		// this is deviation from microsoft standards, introduced below terms for text padding inside shape
		// lp:- left padding, rp: right padding, tp: top padding, bp: bottom padding
		// As per microsoft specification (section 21.1.2.1.1) we should introduce bodyPr(Body properties) however
		// for now we are now going with this approach, will do it in future.
		{ name: "lp", fmla: { operation: FP.AddSubtract, operands: ["l", 10, 0] } },
		{ name: "rp", fmla: { operation: FP.AddSubtract, operands: ["r", 0, 10] } },
		{ name: "tp", fmla: { operation: FP.AddSubtract, operands: ["t", 2, 0] } },
		{ name: "bp", fmla: { operation: FP.AddSubtract, operands: ["b", 0, 2] } },
	],
	pathLst: [{
		operations: [
			{ pt: { x: "l", y: "t" }, type: PathOperationTypes.MOVE_TO },
			{ pt: { x: "r", y: "t" }, type: PathOperationTypes.LINE_TO },
			{ pt: { x: "r", y: "b" }, type: PathOperationTypes.LINE_TO },
			{ pt: { x: "l", y: "b" }, type: PathOperationTypes.LINE_TO },
			{ type: PathOperationTypes.CLOSE },
		],
	}],
	presetShape: ShapeType.rect,
	rect: { l: "lp", t: "tp", r: "rp", b: "bp" },
	type: GeometryTypes.PRESET,
};

/**
 * Microsoft open xml preset definition (for Reference purpose only)
 *
 * <rect>
 *   <cxnLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *     <cxn ang="3cd4">
 *       <pos x="hc" y="t" />
 *     </cxn>
 *     <cxn ang="cd2">
 *       <pos x="l" y="vc" />
 *     </cxn>
 *     <cxn ang="cd4">
 *       <pos x="hc" y="b" />
 *     </cxn>
 *     <cxn ang="0">
 *       <pos x="r" y="vc" />
 *     </cxn>
 *   </cxnLst>
 *   <rect l="l" t="t" r="r" b="b" xmlns="http://schemas.openxmlformats.org/drawingml/2006/main" />
 *   <pathLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *     <path>
 *       <moveTo>
 *         <pt x="l" y="t" />
 *       </moveTo>
 *       <lnTo>
 *         <pt x="r" y="t" />
 *       </lnTo>
 *       <lnTo>
 *         <pt x="r" y="b" />
 *       </lnTo>
 *       <lnTo>
 *         <pt x="l" y="b" />
 *       </lnTo>
 *       <close />
 *     </path>
 *   </pathLst>
 * </rect>
 */
